import * as React from "react";

import clsx from "clsx";

import { Link } from "~components/Link";
import { Typography } from "~components/Typography";

import * as styles from "~sections/Nav/desktop/styles.css";

import type { StoryblokFieldLink } from "~types/storyblok.types";

interface NavLinkProps {
  className?: string;
  title: string;
  link: StoryblokFieldLink;
}

export const NavLink = React.forwardRef<HTMLAnchorElement, NavLinkProps>(
  ({ className, title, link }, forwardedRef) => {
    return (
      <Link
        className={clsx(styles.navLink, className)}
        link={link}
        ref={forwardedRef}
      >
        <Typography className={styles.navLinkHeading} as="span">
          {title}
        </Typography>
      </Link>
    );
  }
);
